export const FUNNEL_STEP = {
  LANDING: 'landing',
  LISTING: 'listing',
  REVIEW: 'review',
  PAYMENT: 'payment',
  THANKYOU: 'thankyou',
  DETAIL: 'detail',
} as const;
